import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Container,
  Stack,
  Typography,
  Grid,
  Button,
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";

// import InboxIcon from "@mui/icons-material/Inbox";
// import DraftsIcon from "@mui/icons-material/Drafts";

import Iconify from "../../components/Iconify";
import Page from "../../components/Page";
import CodeMirror from "@uiw/react-codemirror";
import Select, { components } from "react-select";
import { FaAngleDown } from "react-icons/fa";

const DocumentationAPI = () => {
  const datacode = "console.log('Code Mirror!');\nconsole.log('Code Mirror!');";
  const handleCopy = (str) => {
    navigator.clipboard.writeText(str);
  };

  const navigate = useNavigate();

  const DropdownIndicator = (props) => {
    return (
      components.DropdownIndicator && (
        <components.DropdownIndicator {...props}>
          <FaAngleDown color={"grey"} />
        </components.DropdownIndicator>
      )
    );
  };

  return (
    <Page title="Broadcast">
      <Container>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
          }}
        >
          <div
            onClick={() => {
              navigate(-1);
            }}
            style={{
              cursor: "pointer",
            }}
          >
            <Iconify
              width={60}
              height={60}
              color={"#DBDBDB"}
              icon="ion:arrow-back-circle"
              sx={{ marginRight: 1 }}
            />
          </div>

          <Stack direction="column" justifyContent="center">
            <Typography variant="h4">Documentation API</Typography>
          </Stack>
        </div>
        <Grid container spacing={2} sx={{ marginY: "20px" }}>
          <Grid item xs={3}>
            <Box
              sx={{ width: "100%", maxWidth: 360, bgcolor: "background.paper" }}
            >
              <nav aria-label="main mailbox folders">
                <List>
                  <ListItem disablePadding>
                    <ListItemButton>
                      <ListItemIcon>
                        <Iconify
                          width="16px"
                          height="16px"
                          color={"#722FF2"}
                          icon="icon-park-outline:send"
                          sx={{ marginRight: 1 }}
                        />
                      </ListItemIcon>
                      <ListItemText color="#722FF2" primary="Request Send" />
                    </ListItemButton>
                  </ListItem>
                  <ListItem disablePadding>
                    <ListItemButton>
                      <ListItemIcon>
                        <Iconify
                          width="16px"
                          height="16px"
                          color={"#722FF2"}
                          icon="ic:baseline-whatsapp"
                          sx={{ marginRight: 1 }}
                        />
                      </ListItemIcon>
                      <ListItemText color="#722FF2" primary="Responses" />
                    </ListItemButton>
                  </ListItem>
                </List>
              </nav>
            </Box>
          </Grid>
          <Grid item xs={9}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                marginY: 2,
              }}
            >
              <Box>
                <Select
                  menuPortalTarget={document.body}
                  onChange={(option) => {}}
                  options={[
                    {
                      value: "javascript",
                      label: "Javascript",
                    },
                    {
                      value: "php",
                      label: "PHP",
                    },
                    {
                      value: "pypthon",
                      label: "Python",
                    },
                  ]}
                  styles={{
                    option: (provided, state) => ({
                      ...provided,
                      cursor: "pointer",
                    }),
                    control: (provided) => ({
                      ...provided,
                      borderColor: "#e6e6e6",
                    }),
                    container: (provided) => ({
                      ...provided,
                      width: "100%",
                    }),
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    menu: (provided) => ({
                      ...provided,
                      zIndex: "9999 !important",
                    }),
                  }}
                  components={{
                    DropdownIndicator,
                    IndicatorSeparator: () => null,
                  }}
                />
              </Box>
              <Button onClick={() => handleCopy(datacode)} variant="contained">
                Copy code
              </Button>
            </Box>
            <CodeMirror value={datacode} height="100px" />
          </Grid>
        </Grid>
      </Container>
    </Page>
  );
};

export default DocumentationAPI;
